const actions = {
  GET_PRODUCT_PROFITABILITY_REQUEST: "GET_PRODUCT_PROFITABILITY_REQUEST",
  GET_PRODUCT_PROFITABILITY_SUCCESS: "GET_PRODUCT_PROFITABILITY_SUCCESS",

  getProductProfitabilityData: (params) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_PRODUCT_PROFITABILITY_REQUEST,
        ...params,
      });
    };
  },
};
export default actions;
